// Switch Role / View As Role (Phase 1) -- transport.
//
// There is no central fetch/axios wrapper anywhere in front_elakay today:
// every one of the ~90+ call sites (src/includes/auth/index.js and beyond)
// builds its own `fetch(url, {...})`. Retrofitting the selected-role header
// into every one of them individually is out of scope for Phase 1 (3 proof
// surfaces only) and would be a large, error-prone diff.
//
// Instead this wraps window.fetch ONCE at bootstrap (see src/index.js),
// scoped strictly to same-origin Elakay API calls, and only ever ADDS the
// header when a role switch is actually active. When no override is set
// (the Default/non-regression case), every request this produces is
// byte-identical to what today's code sends -- the strongest possible
// non-regression guarantee at the network layer.
import { elakay_API } from "../../config";
import { getSelectedRoleOverride } from "../pageInside/Rolle";

export const ROLE_SWITCH_REQUEST_HEADER = "X-Elakay-Selected-Role";

export const installRoleSwitchFetchInterceptor = () => {
  if (typeof window === "undefined" || !window.fetch) return;
  if (window.__elakayFetchPatchedForRoleSwitch) return;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const selected = getSelectedRoleOverride();
    if (!selected) return originalFetch(input, init);

    const url = typeof input === "string" ? input : input?.url || "";
    if (!url || !url.startsWith(elakay_API)) return originalFetch(input, init);

    // `init.headers` is frequently a native Headers instance (notably after
    // the sensitive-dropshipping password wrapper). Object spread silently
    // drops every entry of Headers, including Authorization and confirmation
    // tokens. Build a real Headers object and preserve Request headers when
    // the caller did not provide an init override.
    const requestHeaders = typeof Request !== "undefined" && input instanceof Request ? input.headers : undefined;
    const headers = new Headers(init.headers !== undefined ? init.headers : requestHeaders);
    headers.set(ROLE_SWITCH_REQUEST_HEADER, selected);

    return originalFetch(input, {
      ...init,
      headers,
    });
  };
  window.__elakayFetchPatchedForRoleSwitch = true;
};
